import React, { useState } from "react";
import { Grid, Stack, CssBaseline, Box, Input, Typography, List, ListItem, Button, Table, Card, IconButton, Tooltip } from "@mui/joy";
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import { novoDB, triggerLoadNovoDB, unloadDb } from '../dbs/dbsSlice';
import { calculaLivrudoDashboard, calculaResultadosLivrudo, carregaLivrudoDB } from "./LivrudoSlice";
import listaEstados from "./sku_estados";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';


function LivrudoDashboard() {

    var dispatch = useDispatch()
    var loaded = false

    var dbs = useSelector((state) => state.dbs.dbs)
    var livros = useSelector((state) => state.livrudo.db.livros)
    var skus = useSelector((state) => state.livrudo.db.skus)
    var dashboard = useSelector((state) => state.livrudo.dashboard)


    if (Object.keys(dbs).includes("livrudo")) {
        loaded = dbs.livrudo.loaded
    }

    const wait = async () => {
        await new Promise(resolve => setTimeout(resolve, 100)); // Espera 1 segundo
      };
  
    const atualizar = async () => {

        loaded = false
        const dbName = "livrudo"
        dispatch(unloadDb(dbName))
        await wait();
        startLoad();
    }
    const startLoad = async () => {
        const dbName = "livrudo"
        dispatch(triggerLoadNovoDB(
            novoDB(dbName, 10, "db", (p) => {

                var db = p.payload
                var versao = p.versao

                dispatch(carregaLivrudoDB(db != null ? db : {}))
                dispatch(calculaLivrudoDashboard())
                dispatch(calculaResultadosLivrudo())
            })
        ))
    }
    React.useEffect(() => {
        startLoad()
    }, []);

    const [searchTerm, setSearchTerm] = useState("");
    const items = ["Maçã", "Banana", "Laranja", "Manga", "Abacaxi", "Uva"];

    const filteredItems = items.filter((item) =>
        item.toLowerCase().includes(searchTerm.toLowerCase())
    );



    function Carregando() {
        return <Grid container>
            <Grid xs={12} sx={{
                diplay: "flex",
                justifyContent: "center",
                textAlign: "center",
                alignItems: "center"
            }}>
                Experando banco de dados...
            </Grid>
        </Grid>
    }

    return !loaded ? <Carregando /> :
        <Grid container sx={{ padding: "5px 10px" }}>
            <Grid xs={12}>
                <Stack direction="row" spacing={2}>
                    <Link to="/livrudo/livros/busca">
                        <Button>Search</Button>
                    </Link>
                    <Link to="/livrudo/calculadora">
                        <Button>Calculadora</Button>
                    </Link>
                    <Link to="/livrudo/resultados">
                        <Button>Resultados</Button>
                    </Link>
                    <Link onClick={() => atualizar()}>
                        <Button color="danger">Atualizar</Button>
                    </Link>
                </Stack>
            </Grid>
            <Grid xs={12}>
                <DashboardPanel data={dashboard} skus={skus} />
            </Grid>
        </Grid>
}


const DashboardPanel = (props) => {

    var estoqueComprado = props.data.estoqueComprado
    var estoqueVendido = props.data.estoqueVendido
    var estoqueCancelado = props.data.estoqueCancelado
    var estoqueCompradoLiquido = estoqueComprado - estoqueCancelado
    var lucro = props.data.lucro
    var faturamento = props.data.faturamento
    var underwater = props.data.underwater
    var estoqueAtual = estoqueCompradoLiquido - estoqueVendido
    // var recebido = 6943.95
    // var recebido = 9505.67
    // var recebido = 11022.64
    // var recebido = 14123.47
    // var recebido = 17179.20
    // var recebido = 19399.79
    // var recebido = 23004.50
    // var recebido = 24669.70
    // var recebido = 26659.44 - 99.2 // Atomos
    // var recebido = 30974.79 - 99.2 // Atomos
    // var recebido = 31536.34 - 99.2 // Atomos
    // var recebido = 34213.10 - 99.2 // Atomos
    var recebido = 38104.66 - 108.2 //  Atomos + C6 cashback

    var amazonCobradoNoCartaoAteAgora = 567.50 // Desatualizado
    var recebidoTitle = "Somatorio do Acompanhamentos 2019 a cada fechamento de mes - Ultimo 15 de Agosto"
    var amazonTitle = "Amazon cobra as vezes no cartão, quando não há saldo eu acho (Atualizado Agosto)"
    var underwaterCaixa = estoqueCompradoLiquido - recebido + amazonCobradoNoCartaoAteAgora
    return (
        <Box sx={{ padding: 2 }}>
            <Grid container spacing={2}>
                {/* Summary Cards */}
                <Grid xs={12} md={4}>
                    <Card>
                        <Stack spacing={1}>
                            <Typography level="h5">Faturamento Liquido</Typography>
                            <Typography level="h5" color="success">
                                R$ {faturamento.toFixed(2)} (ML {((lucro / faturamento) * 100).toFixed(1)}%)
                            </Typography>
                            <Stack direction={"row"} spacing={1} alignItems={"center"}>
                                <Typography level="h5" color="primary">
                                    R$ {recebido.toFixed(2)} (Recebido)
                                </Typography>
                                <Tooltip title={recebidoTitle}>
                                        <HelpOutlineIcon />
                                </Tooltip>
                            </Stack>
                            <Stack direction={"row"} spacing={1} alignItems={"center"}>
                                <Typography level="h5" color="danger">
                                    R$ {amazonCobradoNoCartaoAteAgora} (Amz Extra)
                                </Typography>
                                <Tooltip title={amazonTitle}>
                                        <HelpOutlineIcon />
                                </Tooltip>
                            </Stack>
                            <Stack direction={"row"} spacing={1} alignItems={"center"}>
                                <Typography level="h5" color="danger">
                                    R$ {(faturamento - recebido + amazonCobradoNoCartaoAteAgora).toFixed(2)} (Restante)
                                </Typography>
                            </Stack>
                        </Stack>
                    </Card>
                </Grid>
                <Grid xs={12} md={4}>
                    <Card>
                        <Typography level="h5">Lucro</Typography>
                        <Typography level="h4" color="info">
                            R$ {lucro.toFixed(2)} (ROI {((lucro / estoqueVendido) * 100).toFixed(1)}%)
                        </Typography>
                    </Card>
                </Grid>
                <Grid xs={12} md={4}>
                    <Card>
                        <Box sx={{ marginTop: 2 }}>
                            <Typography level="h5">Saldo do Estoque</Typography>
                            <Typography level="body1">Comprado (Liquido): R$ {(estoqueCompradoLiquido).toFixed(2)}</Typography>
                            {/* <Typography level="body1">Cancelado: R$ {estoqueCancelado.toFixed(2)}</Typography> */}
                            <Typography level="body1">Vendido: R$ {estoqueVendido.toFixed(2)}</Typography>
                            <Typography level="body1">Atual: R$ {(estoqueAtual).toFixed(2)}</Typography>
                            <Typography level="body1">Underwater (Competencia): R$ {(underwater).toFixed(2)}</Typography>
                            <Typography level="body1">Underwater (Caixa): R$ {(underwaterCaixa).toFixed(2)}</Typography>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
            <Box sx={{ marginTop: 3 }}>
                <Card>
                    <Table>
                        <tbody>
                            <tr>
                                <td style={{ width: "100px" }}>Quantidade</td>
                                <td>Pendencia</td>
                            </tr>
                            {listaEstados.map(a => {
                                var filtrados = props.skus.filter(s => s.ultimoEstado == a)
                                var t = filtrados.length
                                var soma = filtrados.reduce((total, item) => parseFloat(item.preco) + total, 0)
                                return <tr key={a}>
                                    <td>
                                        {t > 0 ? t : "-"}
                                    </td>
                                    <td>
                                        <Link to={"/livrudo/skus/busca?estado=" + a}>
                                            {a}
                                        </Link> (R$ {soma.toFixed(2)}) {((soma / estoqueAtual) * 100).toFixed(2)}%
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </Table>
                </Card>
            </Box>
        </Box>
    );
};

export default LivrudoDashboard